<template>
  <div class="cms-frame-mask" v-if="visible">
    <div class="frame-body">
      <img src="../img/corner-t-icon.png" alt="" class="top left">
      <img src="../img/corner-t-icon.png" alt="" class="top right">
      <img src="../img/corner-b-icon.png" alt="" class="bottom right">
      <img src="../img/corner-b-icon.png" alt="" class="bottom left">
      <em class="close" @click="close"></em>
      <iframe title="" :src="iframeSrc" class="frame" allowfullscreen allow="autoplay"></iframe>
    </div>
  </div>
</template>

<script>
import '../less/frame.css';
export default {
  name: 'CmsFramePlayer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = null;
      }
    }
  },
  computed: {
    iframeSrc() {
      const scale = document.documentElement.clientWidth / 1920;
      const w = Math.round(960 * scale);
      const h = Math.round(540 * scale);
      return this.src + `&iframe=yes&aspect=${w}x${h}`
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsFramePlayer.vue